import { render, staticRenderFns } from "./NavBarMobile.vue?vue&type=template&id=54564818&"
import script from "./NavBarMobile.vue?vue&type=script&lang=js&"
export * from "./NavBarMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports